import Vue from 'vue'
import SvgPlugin from './src'

Vue.use(SvgPlugin)
